import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'
/**
 * 创建项目
 * @param {*} params
 */
export function createProject(data) {
    return axiosIns({
        url: `/api/pc/project/add`,
        method: 'post',
        owner:epmcore,
        data: data,
    })
}

/**
 * 查询项目列表
 */
export function listProject() {
    return axiosIns({
        url: `/api/pc/project/listProject`,
        owner:epmcore,
        method: 'get',
    })
}

export function getProjectPermission(projectId) {
    return axiosIns({
        url: `/api/pc/permission/getProjectPermission/${projectId}`,
        owner:epmcore,
        method: 'get',
    })
}



/**
 * 删除项目
 * @param {项目id} id
 */
export function deleteProject(id) {
    return axiosIns({
        url: `/api/pc/project/${id}`,
        owner:epmcore,
        method: 'delete'
    })
}

/**
 * 分页查询项目
 * @param {*} params
 */
export function pageProject(params) {
    return axiosIns({
        url:`/api/pc/project/page`,
        owner: epmcore,
        method: 'get',
        params: params
    })
}

/**
 * 查询项目版本
 * @param {*项目id} id
 */
export function listProjectVersion(params) {
    return axiosIns({
        url:`/api/pc/projectVersion/page`,
        owner: epmcore,
        method: 'get',
        params: params
    })
}

/**
 * 修改项目版本
 */
export function updateProjectVersion(data) {
    return axiosIns({
        url: `/api/pc/projectVersion/update`,
        owner: epmcore,
        method: 'put',
        data: data
    })
}

/**
 * 更新项目版本阶段
 * @param {*} data
 */
export function updateState(data) {
    return axiosIns({
        url: `/api/pc/projectVersion/updateStage`,
        owner: epmcore,
        method: 'put',
        data: data,
    })
}

/**
 * 关闭项目
 * @param {项目id} id
 */
export function closeProject(id) {
    return axiosIns({
        url: `/api/pc/project/close/${id}`,
        owner: epmcore,
        method: 'put',
    })
}

export function getProjectStageNum(params) {
    return axiosIns({
        url:`/api/pc/project/getProjectStageNum`,
        owner: epmcore,
        method: 'get',
        params: params
    })
}

export function getStatisticsProjectVersionPartData(params) {
    return axiosIns({
        url:`/api/pc/statistics/getStatisticsProjectVersionPartData`,
        owner: epmcore,
        method: 'get',
        params: params
    })
}

export function checkStage(){
  const s = localStorage.getItem('projectStage')
  return !(s && Number(s) !== 7);
}



// WEBPACK FOOTER //
// ./src/views/project-manage/projectManagerAPI.js